import styled from 'styled-components/macro'

const Spacer = styled.div`
  height: ${(props) => (props.height ? props.height : '2.4rem')};
  width: ${(props) => (props.width ? props.width : '0')};
`

export default Spacer
